var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"blog-listing-page"},[_c('HeroBanner',{attrs:{"color":"blue","heading":_vm.heading}}),_c('div',{staticClass:"page-main"},[_c('h3',{staticClass:"main-heading"},[_vm._v("Parcours nos articles.")]),(_vm.blogEntries)?_c('BlogCards',{attrs:{"cards":_vm.blogEntries}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }